import { render } from "./OnlineUsers.vue?vue&type=template&id=1628f1a6"
import script from "./OnlineUsers.vue?vue&type=script&lang=js"
export * from "./OnlineUsers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__